import { UserSecret } from '../models/user-secret';

/**
 * Map to user secret.
 * @param {object} dto Dto.
 * @returns {UserSecret}
 */
function mapSecretFromDto(dto) {
  return new UserSecret({
    userSecret: dto.api_token,
  });
}

export const authMapper = {
  mapSecretFromDto,
};
